import {GoToDetail} from 'components/grid-dx/consult-buttons';
import IntegrityRoleGrid from 'components/UserRole';
import {Column, Lookup} from 'devextreme-react/data-grid';
import {lookupStatus} from 'features/course/components/CourseGrid';
import {lookupModality} from 'features/instance/component/StageGrid';
import React from 'react';
import {i18n2} from '../../i18n/i18n';
import {useLoadStage} from '../../instance/hooks';
import {LookupProps} from 'components/grid-dx/MasterGrid';
import {useIsTablet} from 'components/hooks/useIsTablet';
import {
  useActionButtonStyles,
  getActionColumnWidth,
} from 'components/grid-dx/styles/actionButtonStyles';

interface ButtonsProps {
  data: any;
  props: any;
}

const Buttons = ({data, props}: ButtonsProps) => {
  const id = props.key;
  const isTablet = useIsTablet();
  const styles = useActionButtonStyles();
  return (
    <div
      className={isTablet ? styles.tabletContainer : styles.compactContainer}>
      <GoToDetail data={data} id={id} url={'/ReadStagesDetail'} />
    </div>
  );
};

const InstanceReadOnly = () => {
  const loadStage = useLoadStage(true);
  const isTablet = useIsTablet();

  return (
    <IntegrityRoleGrid
      dataSource={loadStage}
      id={['iD_Instance', 'iD_Course']}
      allowIntegrity={false}
      allowActions={false}
      exportName="Instance-consult-export">
      <Column caption={i18n2._('#Curso')} dataField="iD_Course" width="5%" />
      <Column
        caption={i18n2._('#Instancia')}
        dataField="iD_Instance"
        width="5%"
      />
      <Column
        caption={i18n2._('Nombre del curso')}
        dataField="name_Course"
        width="40%"
      />
      <Column
        caption={i18n2._('Documento')}
        dataField="doc_Number"
        width="10%"
      />
      <Column caption={i18n2._('Modalidad')} dataField="modality">
        <Lookup
          dataSource={lookupModality}
          valueExpr="id"
          displayExpr={(item: LookupProps) => {
            return i18n2._(item ? item.name : '');
          }}
        />
      </Column>
      <Column caption={i18n2._('Sector')} dataField="sector_Name" width="12%" />
      <Column
        caption={i18n2._('Fecha de instancia')}
        dataField="instance_Date"
        dataType="date"
        format="dd/MM/yyyy"
        calculateCellValue={(row: any) => new Date(row.instance_Date)}
        width="7%"
      />
      <Column
        caption={i18n2._('Estado del curso')}
        dataField="status_Course"
        width="7%">
        <Lookup
          dataSource={lookupStatus}
          valueExpr="id"
          displayExpr={(item: LookupProps) => {
            return i18n2._(item ? item.name : '');
          }}
        />
      </Column>
      <Column
        caption={i18n2._('OnTime (%)')}
        dataField="onTimeRate"
        width="5%"
      />
      <Column
        caption={i18n2._('Asistencia') + '(%)'}
        dataField="presentRate"
        width="5%"
      />
      <Column
        caption={i18n2._('Aprobados') + '(%)'}
        dataField="passRate"
        width="5%"
      />
      <Column
        caption=""
        cellComponent={(e: any) => (
          <Buttons data={e.data.data} props={e.data} />
        )}
        width={getActionColumnWidth(1, isTablet)}
        fixed
        alignment="right"
      />
    </IntegrityRoleGrid>
  );
};

export default InstanceReadOnly;
